<template>
  <CCard>      
      <CCardBody>
            <div class="max-w-xl mx-auto mt-10 border rounded-lg shadow-lg flex flex-col h-[600px]">  
              <div class="flex-1 p-4 overflow-y-auto bg-gray-50 space-y-2">                
                <div style="padding-top: 20px;"                
                  v-for="msg in messages"
                  :key="msg.id"
                  :class="msg.user === 'SCM' ? 'text-right' : 'text-left'">
                  <div v-if="msg.user === 'PCCV'" style='width: 10%; display: inline-block;'><img :src="pccv_img" style="height:40px;"/></div>
                  <div style="width: 90%; display: inline-block;"
                    :class="msg.user === 'SCM' ? 'bg-blue-100 text-blue-900' : 'bg-gray-200 text-gray-800'"
                    class="inline-block px-4 py-2 rounded-lg max-w-xs col-lg-12 " >
                    {{ msg.text }}
                  </div>
                  <div v-if="msg.user === 'SCM'" style='width: 10%; display: inline-block;'><img :src="scm_img" style="height:40px;"/></div>
                </div>
              </div>

              <!-- Input Box -->
              <div class="p-4 border-t flex gap-2" >
                <input
                  v-model="newMessage"
                  @keyup.enter="send"
                  class="flex-1 border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  style="width: 85%;"
                  placeholder="輸入訊息..."
                />
                <button
                  @click="send"
                  class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
                  送出
                </button>
              </div>
            </div>
           
      </CCardBody>
  </CCard>
</template>

<script>
import Vue from "vue";
import logoImg from '../../../../public/img/avatars/logo2.png';  
import scmImg from '../../../../public/img/avatars/scm03.svg';  
export default {
  data() {
    return {
      ua: null, sku: null, pccv: null, c_no: null,
      pccv_img: logoImg,
      scm_img: scmImg,
      newMessage: '',
      messages: []
    }
  },
  methods: {
    onload:function(c_no, ua, sku, pccv) {
      this.c_no = c_no;
      this.ua = ua;
      this.sku = sku;
      this.pccv = pccv;
      this.getMsg();
    },
    send() {
      if (!this.newMessage.trim()) return
      this.postMsg(this.newMessage);
    },

    postMsg(msg) {
      this.newMessage = "";
      this.messages = [];
      this.axios({
          method: 'post',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/SCM/Notify`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {
            no : this.c_no,
            ua : this.ua,
            sku : this.sku,
            is_pccv : true,
            msg : msg
          }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
        this.getMsg();
      })
      .catch((error) => { 
        console.log(error);
      }
      )    
    },

    getMsg() {      
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/SCM/Notify?ua=${this.ua}&sku=${this.sku}&ispccv=true`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
        this.messages = response.data.datas;
        console.log(this.messages );
      })
      .catch((error) => { 
        console.log(error);
      }
      )    
    }
  }
}
</script>
<style>
  .bg-blue-100 {
    border: 1px solid gray;
  }
  .bg-blue-500 {
    background-color: red;
  }
</style>